// components/EditableInput.tsx
import React, { useState } from 'react';
import { Input, InputGroup, InputRightElement, IconButton, HStack } from '@chakra-ui/react';
import { EditIcon, CheckIcon, CloseIcon } from '@chakra-ui/icons';

type EditableInputProps = {
    value: string;
    onSave: (newValue: string) => void;
};

const EditableInput: React.FC<EditableInputProps> = ({ value: initialValue, onSave }) => {
  const [value, setValue] = useState<string>(initialValue);
  const [isEditing, setIsEditing] = useState<boolean>(false);

  const handleEdit = () => setIsEditing(true);

  const handleSave = () => {
    onSave(value);
    setIsEditing(false);
  };

  const handleDiscard = () => {
    setValue(initialValue); // Reset to the initial value
    setIsEditing(false);     // Exit edit mode
  };

  return (
    <InputGroup>
      <Input
        value={value}
        onChange={(e) => setValue(e.target.value)}
        isReadOnly={!isEditing}
        isDisabled={!isEditing}
        cursor={isEditing ? 'text' : "default"}
      />
      <InputRightElement width="4.5rem">
        <HStack spacing={0}>
          {isEditing ? (
            <>
              <IconButton
                variant="ghost"
                aria-label="Save"
                icon={<CheckIcon />}
                onClick={handleSave}
                size="sm"
              />
              <IconButton
                variant="ghost"
                aria-label="Discard"
                icon={<CloseIcon />}
                onClick={handleDiscard}
                size="sm"
              />
            </>
          ) : (
            <IconButton
              variant="ghost"
              aria-label="Edit"
              icon={<EditIcon />}
              onClick={handleEdit}
              size="sm"
            />
          )}
        </HStack>
      </InputRightElement>
    </InputGroup>
  );
};

export default EditableInput;
